<template>
  <div class="form-group esma_form_group">
    <label v-bind:for="fieldID" class="col-xs-4 control-label esma_form_label">{{fieldLabel}}</label>
    <div class="col-xs-8" style="padding:1px 0px 1px 7px;">
      <div class="radio-inline"  v-for="b in buttons" :key="b.text"  v-on:click="onClick(b,$event)" >
        <label>
          <input  
          :style="filedStyle"
          type="radio" 
          :name="fieldLabel" 
          :id="fieldLabel"  
          :value="b.text" 
          :checked="isChecked(b.text)"
          :disabled="isDisabled" 
          > {{b.label}}</label>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from '@/libs/bus'
export default {
  methods: {
    onClick(d, event) {
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d.text
    },
    isChecked(val){
      // console.log("check : ",val, "," ,this.$store.state[this.stateCurrentRow][this.fieldID],", TEST VALUE ,", this.$props.value,",",this.fieldID)
      return this.$store.state[this.stateCurrentRow][this.fieldID] == val
    }
  },
  computed: {
    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    buttons() {
      return this.$props.data.buttons
    },
    fieldLabel() {
      return this.$props.data.label
    },
    fieldValue() {
      return this.$store.state[this.stateCurrentEditing][this.fieldID]
    },
    
    fieldID() {
      return this.$props.data.id
    },
    isDisabled() {

      return this.$props.data.disabled  ||  this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"
    }

  },
  mounted(){
    this.$props.data.ref_field = this;
    if(typeof this.$props.data.set_global_on != "undefined"){
      
      bus.$on(this.$props.data.set_global_on.watch,(val)=>{
        var new_val = this.$props.data.set_global_on.options[val] || false
        console.log("RADIO RECEIVED ", this.$props.data.set_global_on.watch ," event with ",val, "to set to ", new_val )
        if(new_val){
          this.$store.state[this.stateCurrentRow][this.fieldID] = new_val
          this.$store.state[this.stateCurrentEditing][this.fieldID]= new_val
        }
        
      })  
    }
  },beforeDestroy(){
    if(typeof this.$props.data.set_global_on != "undefined"){
      
      bus.$off(this.$props.data.set_global_on.watch)  
    }
  },

  props: ['data', 'value','read']
}
</script>
<style scoped>
.form-control::selection {
  color: white;
  background: #575757;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #cccccc;
}

.form-control {
  color: black;
    height: 24px;
}
</style>


// WEBPACK FOOTER //
// radio-button.vue?36e65213